module.exports = __webpack_public_path__ + "static/media/valores.8365f43a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/valores.svg
// module id = 186
// module chunks = 0